/*
 * File: InsuranceAndGuarantorsLinks.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 10/17/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates the links for the insurance and guarantors page
 */
import React from "react";
import UILinkList from "components/ui/UILinkList";
import PatientId from "services/patients/store/PatientIdStore";

const InsuranceAndGuarantorsLinks = () => {
  const patientId = PatientId.getId();
  const insuranceAndGuarantorsURL =
    "/patients/" + patientId + "/insurance_and_guarantors/";
  const insuranceLinks = [
    {
      primaryString: "Insurance",
      url: insuranceAndGuarantorsURL + "insurance"
    },
    {
      primaryString: "Guarantors",
      url: insuranceAndGuarantorsURL + "guarantors"
    }
  ];

  return <UILinkList links={insuranceLinks} />;
};

export default InsuranceAndGuarantorsLinks;
